<template>
  <section class="terms-of-service">
    <div class="container">
      <breadcrumb
        :menu-list="[{link:null, title:$route.meta.title}]"
        />
      <h1>利用規約</h1>
      <vue-markdown :source="source"></vue-markdown>
    </div>
  </section>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue';
import VueMarkdown from 'vue-markdown';
import text from 'raw-loader!./TermsOfService.md';

export default {
  name: 'TermsOfService',
  components: {
    Breadcrumb,
    VueMarkdown,
  },
  data() {
    return {
      source: '',
    };
  },
  mounted() {
    scrollTo(0, 0);
    this.source = text;
  },
}
</script>

<style scoped lang="scss">
h1 {
  margin-bottom:2rem;
}
h2 {
  margin-bottom: 1.5rem;
}
.logo {
  margin: 10px 20px 10px 10px;
}
section { 
  text-align: left;
  margin: 3rem 0;
}
</style>
